import { render } from "./CompanyList-Authorities.vue?vue&type=template&id=e9745142&ts=true"
import script from "./CompanyList-Authorities.vue?vue&type=script&lang=ts"
export * from "./CompanyList-Authorities.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__